import React, { Component } from 'react';
import {Button, ButtonGroup} from 'reactstrap';
import Header from './HeaderComponent';
import {graphs} from '../shared/graphs';

class DFS extends Component{
    constructor(props){
        super(props);

        this.state={
            graph: graphs[0]
        }
        this.parent=[];
        this.color=[];
        this.DFS = this.DFS.bind(this);
        this.reset = this.reset.bind(this);
    }

    reset(){
        this.state.graph.nodes.map((node) => document.getElementById(node.id).style.fill = "red");
        this.state.graph.edges.map((edge) => document.getElementById(edge.id).style.stroke = "#006400");
        this.parent = [];
        this.color = [];
    }
    sleep(ms) {
        return new Promise(
          resolve => setTimeout(resolve, ms)
        );
    }
    async DFS(network){
        for(var i=0; i<network.length; i++){
            this.parent.push(null);
            this.color.push(0);
        }
        for(i=0; i<network.length; i++){
            if(this.color[i] === 0){
                await this.DFS_Visit(network, i);
            }
        }
    }
    async DFS_Visit(network, node){
        this.color[node] = 1;
        var edge_id;
        for(var j=0; j<network.length; j++){
            if(network[node][j] !== 0){
                if(this.color[j]===0){
                    if(node<j){
                        edge_id = (node+1)+"to"+(j+1);
                    }
                    else{
                        edge_id = (j+1)+"to"+(node+1);
                    }
                    await this.sleep(1000);
                    document.getElementById(edge_id).style.stroke = "#FF4500";
                    this.parent[j] = node;
                    await this.DFS_Visit(network, j);
                }
            }
        }
        await this.sleep(1000);
        var node_id = "n"+(node+1);
        document.getElementById(node_id).style.fill = "blue";
        this.color[node] = 2;
    }

    render(){
        const renderEdges = this.state.graph.edges.map((edge)=>{
            return(
                <line id={edge.id} x1={edge.x1} y1={edge.y1} x2={edge.x2} y2={edge.y2} stroke="#006400" stroke-width="3" />
            );
        });
        const renderNodes = this.state.graph.nodes.map((node) => {
            return(
                <>
                    <circle id={node.id} cx={node.cx} cy={node.cy} r="20" stroke="black" stroke-width="3" fill="red"/>
                    <text id={node.textId} x={node.cx} y={node.cy} text-anchor="middle" stroke="#ffffff" stroke-width="1px" dy=".3em">{node.text}</text>
                </>
            );
        });
        return(
            <>
                <Header destination="Depth First Search"/>
                <div className="container">
                    <div className="p-2 border black-yellow mb-2">
                        <div className="row mb-2 mt-2">
                            <div className="col-12">
                                <h4>Introduction to DFS</h4>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-12">
                                <p>Depth-first search is an algorithm for traversing or searching tree or graph data structures. The algorithm starts at the root node (selecting some arbitrary node as the root node in the case of a graph) and explores as far as possible along each branch before backtracking. So the basic idea is to start from the root or any arbitrary node and mark the node and move to the adjacent unmarked node and continue this loop until there is no unmarked adjacent node. Then backtrack and check for other unmarked nodes and traverse them. Finally print the nodes in the path.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-12 text-center">
                            <ButtonGroup>
                                <Button onClick={() => {
                                    this.setState({graph: graphs[0]});
                                    this.reset();
                                    }}>1</Button>
                                <Button onClick={() => {
                                    this.setState({graph: graphs[1]});
                                    this.reset();
                                    }}>2</Button>
                                <Button onClick={() => {
                                    this.setState({graph: graphs[2]});
                                    this.reset();
                                    }}>3</Button>
                            </ButtonGroup>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <svg height="500" width="500">
                                {renderEdges}
                                {renderNodes}
                            </svg>
                        </div>
                        <div className="col-12 col-md-6">
                            <Button onClick={() => {this.DFS(this.state.graph.network)}} color="primary">Start DFS</Button>
                            <Button onClick={this.reset} color="danger">Reset Graph</Button>
                        </div>
                    </div>
                    
                </div>
            </>
        );
    }
}

export default DFS;